import { AI_FORM_ITEMS_KEY_REPLACER } from "Common/constant";
import React, { useEffect, useState } from "react";
import "./NestedFormViewer.scss";
import { Divider } from "antd";
import utils from "utils";
const changeableArray = ["is_drugs", "key3"];

// const AI_FORM_ITEMS_KEY_REPLACER = {
//   is_drugs: "",
//   is_abuse: "",
//   is_recurrent: "",
//   is_emotional_abuse: "",
//   sexual_abuse_value: "",
//   duration_period: "Duration Period",
//   duration: "Duration",
//   quantity: "Quantity",
//   is_abstinence: "",
//   reason_for_relapse: "Reason",
// };

const renderKeyValSection = (key, value) => {
  let transKey =
    AI_FORM_ITEMS_KEY_REPLACER[key] ?? utils.Capitalize(key.replace(/_/g, " "));

  if (transKey == "") {
    return <div key={key}>{value}</div>;
  } else {
    return (
      <div key={key} style={{ padding: "12px 0px" }}>
        <span
          style={{ background: "#F2F4F7", padding: "8px" }}
          className="key-value-section"
        >
          {transKey} : {value}
        </span>
      </div>
    );
  }
};

const renderDivs = (obj, depth = 0) => {
  if (typeof obj === "string") {
    return <span>{obj}</span>;
  } else {
    const className = `depthlevel-${depth}`;
    const paddingStyle = {
      paddingLeft: `${depth * 20}px`,
    };

    return Object.entries(obj).map(([key, value], index) => {
      // if (typeof value == "boolean" && value) {
      if (typeof value == "boolean") {
        // value = "Yes";
        value = value ? "Yes" : "No";
      }

      if (Array.isArray(value)) {
        let result = "";
        if (value.some((item) => typeof item === "object")) {
          result = (
            <div className="nestedwith-divider">
              <Divider className="divider-aff-form" />
              <div
                key={key}
                className={`${className} nested-div`}
                style={paddingStyle}
              >
                <span className={`key-span`}>
                  {/* {key.charAt(0).toUpperCase() + key.slice(1)} */}
                  {utils.capitalizeAndReplace(key)}
                </span>
                <br />
                {/* :&nbsp; */}
                {value.map((item, itemIndex) => (
                  <>
                    {" "}
                    {renderDivs(item, depth + 1)}
                    <br />
                  </>
                ))}
              </div>
            </div>
          );
        } else {
          result = renderDivs({ [key]: value.join(", ") }, depth + 1);
        }
        value = result;
        return value;
      }

      if (typeof value === "object" && value !== null) {
        return (
          <div className="nestedwith-divider">
            <Divider className="divider-aff-form" />
            <div
              key={key}
              className={`${className} nested-div`}
              style={paddingStyle}
            >
              <span className={`key-span`}>
                {/* {key.charAt(0).toUpperCase() + key.slice(1)} */}
                {utils.capitalizeAndReplace(key)}
              </span>
              <br />
              {/* :&nbsp; */}
              {renderDivs(value, depth + 1)}
            </div>
          </div>
        );
      } else {
        const separator = index === 0 ? "" : " | ";
        return (
          <span
            key={key}
            className="key-nested-form"
            // className={className}
            // style={paddingStyle}
          >
            {/* {separator} */}
            {/* <div>{value}</div> */}
            {/* <span className="summary-key-span">{key}</span>{" "}
            <span> {` : `} </span>
            <span className="value-span">{value}</span> */}
            {/* <div>
              {key} : {value}
            </div> */}

            {renderKeyValSection(key, value)}
          </span>
        );
      }
    });
  }
};
const renderKeyValSectionNew = (key, value) => {
  let transKey =
    AI_FORM_ITEMS_KEY_REPLACER[key] ?? utils.Capitalize(key.replace(/_/g, " "));

  if (transKey == "") {
    return <div key={key}>{value}</div>;
  } else {
    return (
      <div
        key={key}
        style={{
          background: "#F2F4F7",
          padding: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap:"8px",
        }}
        className="key-value-section"
      >
        <div className="label">{transKey}</div>
        <div className="value"> {value}</div>
      </div>
    );
  }
};
const renderDivsNew = (obj, depth = 0) => {
  if (typeof obj === "string") return <span>{obj}</span>;

  return Object.entries(obj).map(([key, value]) => {
    if (typeof value === "boolean") value = value ? "Yes" : "No";

    if (Array.isArray(value)) {
      const hasObjects = value.some((item) => typeof item === "object");
      return hasObjects ? (
        <div key={key} className="objectParent">
          <div className="objectTitleDiv">
            <div className="objectTitle">{utils.capitalizeAndReplace(key)}</div>
            <div className="objectValue">
              {value[`is_${key}`]
                ? "Yes"
                : value[`is_${key}`] === false
                ? "No"
                : ""}
            </div>
          </div>
          {value.map((item) => {
            // const temparray = Object.fromEntries(
            //   Object.entries(item).filter(
            //     ([childkey]) => childkey !== `is_${key}`
            //   )
            // );
            return (
              <div>
                {renderDivsNew(item, depth + 1)}
                <br />
              </div>
            );
          })}
        </div>
      ) : (
        renderDivsNew({ [key]: value.join(", ") }, depth + 1)
      );
    }

    if (typeof value === "object" && value !== null) {
      const temparray = Object.fromEntries(
        Object.entries(value).filter(([childkey]) => childkey !== `is_${key}`)
      );
      return (
        <div key={key} className="objectParent">
          <div className="objectTitleDiv">
            <div className="objectTitle">{utils.capitalizeAndReplace(key)}</div>
            <div className="objectValue">
              {value[`is_${key}`]
                ? "Yes"
                : value[`is_${key}`] === false
                ? "No"
                : ""}
            </div>
          </div>
          {Object.keys(temparray).length > 0 && (
            <div className="objectItem">
              {renderDivsNew(temparray, depth + 1)}
            </div>
          )}
        </div>
      );
    }

    return <span key={key}>{renderKeyValSectionNew(key, value)}</span>;
  });
};

const moveBooleanValuesToTop = (obj) => {
  const booleanValues = {};
  const newObj = {};
  const nestedObjects = {};

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === "boolean") {
      booleanValues[key] = value;
    } else if (
      !Array.isArray(value) &&
      typeof value === "object" &&
      value !== null
    ) {
      nestedObjects[key] = moveBooleanValuesToTop(value);
    } else {
      newObj[key] = value;
    }
  }

  return { ...booleanValues, ...newObj, ...nestedObjects };
};

const NestedFormViewer = ({ data = {} }) => {
  const [transformedData, setTransformedData] = useState([]);

  useEffect(() => {
    if (typeof data === "object") {
      const tmpData = moveBooleanValuesToTop(data);
      setTransformedData(tmpData);
    } else {
      setTransformedData(data);
    }
  }, [data]);

  return (
    <div>
      <div>{renderDivsNew(transformedData)}</div>
    </div>
  );
};

export default NestedFormViewer;
